import Ajax from "./Ajax"
const GetDeveloper = async(cityId) => {
    const response = await Ajax({
        url: `/developer?limit=false`,
        token: true
    })
    return response.data.result.docs
}
export default GetDeveloper